module.exports = __webpack_public_path__ + "media/components/Builder/Library/Modules/Page/Thumbnails/PoleBanner-fe5614aee987ab9be6fa96c2a6713a0e.jpg";